// extracted by mini-css-extract-plugin
export default {"card":"MP","cardrow":"NP","cardcentered":"OP","details":"PP","imgwrapper":"QP","img":"RP","category":"SP","name":"TP","copy":"UP","detailsbtn":"VP","remove":"WP","price":"XP","netPrice":"YP","regularPrice":"ZP","label":"aQ"};
    if(module.hot) {
      // 1714422956875
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  